import React from 'react';
import type { ProductTestimonial as Testimonial } from '../../types/product';
type ProductTestimonialProps = {
  testimonial: Testimonial;
};
export function ProductTestimonial({
  testimonial
}: ProductTestimonialProps) {
  return <section className="w-full bg-white py-20" aria-label="Customer story" data-id="element-1220" data-mp="1w0t7h7zfsudc">
      <figure className="mx-auto grid max-w-shell grid-cols-1 items-center gap-10 px-6 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] lg:gap-16" data-id="element-1221" data-mp="1rzhnpj38v3d2">
        <img src={testimonial.image} alt={`${testimonial.name}, ${testimonial.role} of ${testimonial.business}`} className="h-[380px] w-full rounded-[14px] object-cover lg:h-[480px]" data-id="element-1222" data-mp="1482h3e4fpzw0" />
        <div data-id="element-1223" data-mp="18c0kw24pfyve">
          <blockquote className="display text-[24px] font-semibold text-ink sm:text-[32px]" data-id="element-1224" data-mp="18b8r8wuo4b7r">
            “{testimonial.quote}”
          </blockquote>
          <figcaption className="mt-8 flex flex-col gap-8 border-t border-canvas-line pt-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-1225" data-mp="kk38o9xcf4tr">
            <div data-id="element-1226" data-mp="3rqndlq0oqvfu">
              <p className="text-[15px] font-semibold text-ink" data-id="element-1227" data-mp="3rr5ckueqfnrg">{testimonial.name}</p>
              <p className="mt-1 text-[14px] text-ink-muted" data-id="element-1228" data-mp="jkhck5zpyyr">
                {testimonial.role}, {testimonial.business} · {testimonial.location}
              </p>
            </div>
            {testimonial.metric && <div className="sm:text-right" data-id="element-1229" data-mp="a8uc67s7xvqk">
                <p className="display text-[36px] font-semibold text-brand" data-id="element-1230" data-mp="abq8xssbyedf">{testimonial.metric.value}</p>
                <p className="mt-1 max-w-[220px] text-[13px] leading-[1.45] text-ink-muted" data-id="element-1231" data-mp="3dqmb664rvfy9">
                  {testimonial.metric.label}
                </p>
              </div>}
          </figcaption>
        </div>
      </figure>
    </section>;
}